import {backendEndpoints} from "../../../libs/backendEndpoints";
import OrderableTable from "../../layout/OrderableTable";
import React from "react";
import {ColumnDef} from "@tanstack/react-table";
import CellRender from "../../layout/table/CellRender";
import SearchInput from "../../SearchInput";
import {ErrorBoundary} from "fearless-common-ui";
import CopyText from "../../layout/CopyText";

interface HttpLog {
  id: number;
  created_at: string;
  url: string;
  method: string;
  response_body: null|string;
  request_body: null|string;
  request_headers: null|string;
}

const columns: ColumnDef<HttpLog>[] = [
  { id: 'created_at', accessorKey: 'created_at', header: 'Date', cell: CellRender.DateTime, enableSorting: false },
  { id: 'method', accessorKey: 'method', header: 'Method', enableSorting: false },
  { id: 'url', accessorKey: 'url', header: 'Url', enableSorting: false, cell: ({ getValue }) => {
    const value = getValue();
    if (typeof value === 'string') {
      return <div className="text-truncate" style={{ maxWidth: '300px' }}>{value.replace(window.location.protocol + '//' + window.location.hostname, '')}</div>;
    }
    return value;
    }},
  { id: 'status', accessorKey: 'status', header: 'Status', enableSorting: false },
  {
    id: 'response_body',
    accessorKey: 'response_body',
    header: 'Response',
    cell: ({ getValue }) => (
      <div className="d-block text-truncate max-width-200">
        <CopyText text={JSON.stringify(getValue())} />
      </div>
    ),
    enableSorting: false,
  },
  {
    id: 'request_body', accessorKey: 'request_body', header: 'Request', enableSorting: false,
    cell: ({ getValue }) => (
      <div className="d-block text-truncate max-width-200">
        <CopyText text={JSON.stringify(getValue())} />
      </div>
    ),
  },
]

export default function HttpLogsTable({ userId }: { userId: number }) {
  const [query, setQuery] = React.useState<string>('');

  return (
    <ErrorBoundary>
      <SearchInput
        onChange={(e) => {
          // @ts-ignore
          setQuery(e.target.value);
        }}
      />
      <OrderableTable
        filterables={[
          {
            field_name: 'status',
            label: 'Status',
            options: [
              { value: '0', label: '0 - ???' },
              { value: '200', label: '200 - OK' },
              { value: '201', label: '201 - Created' },
              { value: '400', label: '400 - Bad request' },
              { value: '401', label: '401 - Unauthorized' },
              { value: '403', label: '403 - Forbidden' },
              { value: '404', label: '404 - Not found' },
              { value: '409', label: '409 - Conflict' },
              { value: '500', label: '500 - Internal server error' },
              { value: '503', label: '503 - Service unavailable' },
            ],
          },
          {
            field_name: 'method',
            label: 'Method',
            options: [
              { value: 'GET', label: 'GET' },
              { value: 'POST', label: 'POST' },
              { value: 'PUT', label: 'PUT' },
              { value: 'DELETE', label: 'DELETE' },
            ],
          }
        ]}
        baseEndpoint={backendEndpoints.getAdminHttpLogs}
        params={{ user_id: userId }}
        memoisedColumns={columns}
        pagination
        // @ts-ignore
        searchQuery={query}
      />
    </ErrorBoundary>
  )
}
